import { createSelector } from 'reselect'
import { getLuxPlusSubscriptionItems } from '../view/luxPlusSubscription'
import getPayableAfterModifiers from './getPayableAfterModifiers'
import { floatify } from 'lib/maths/mathUtils'

const getGiftCardPayableAmount = createSelector(
  (state: App.State) => getPayableAfterModifiers(state),
  (state: App.State) => state.redeemedGiftCards.cards,
  (state: App.State) => state.checkout.cart.currencyCode,
  (state: App.State) => getLuxPlusSubscriptionItems(state),
  (
    payable,
    redeemedCards,
    currencyCode,
    luxPlusCartSubscriptionItems,
  ): number => {
    let maxGiftCardTotal: number

    // Calculate total amount of redeemed gift cards for the current currency
    const giftCardBalance = redeemedCards
      .filter(card => card.currencyCode === currencyCode)
      .reduce((total, card) => total + parseFloat(String(card.amount)), 0)

    maxGiftCardTotal = Math.min(giftCardBalance, payable)

    if (luxPlusCartSubscriptionItems.length > 0) {
      const subscriptionItem = luxPlusCartSubscriptionItems[0]
      const maxGiftCardTotalPayableForSubscription = floatify(payable - subscriptionItem.amount)

      if (maxGiftCardTotal > maxGiftCardTotalPayableForSubscription) {
        maxGiftCardTotal = maxGiftCardTotalPayableForSubscription
      }
    }

    return floatify(maxGiftCardTotal)
  },
)

export default getGiftCardPayableAmount
